import { createSelector } from 'reselect';

import countries from 'app/helpers/countries';

const selMeta = state => state.app.meta;
const selIsServer = state => state.app.isServer;
const selOpenModals = state => state.app.openModals;
const selCfLocation = state => state.app.cfLocation;

const selPageTitle = createSelector(
  [selMeta],
  (meta) => meta.title || 'Millie'
);

const selIsModalOpen = createSelector(
  [selOpenModals],
  (openModals) => {
    return Object.keys(openModals).length > 0;
  }
);

// country from CloudFlare could be blacklisted
const selIpCountryIso2Dirty = createSelector(
  [selCfLocation],
  (cfLoc) => {
    const cc = cfLoc?.countryCode;
    return cc ? cc.toUpperCase() : null;
  }
);
// provides the country code from CloudFlare
// if country is blacklisted, will return null
const selIpCountryIso2 = createSelector(
  [selIpCountryIso2Dirty],
  (cc) => {
    const country = countries.byCode[cc];
    const isAllowedCountry = !!(country && !country.bl);
    return isAllowedCountry ? cc : null;
  }
);

const selIpStateIso2 = createSelector(
  [selCfLocation],
  (cfLoc) => {
    const sc = cfLoc?.regionCode;
    return sc ? sc.toUpperCase() : null;
  }
);

export default {
  meta: selMeta,
  pageTitle: selPageTitle,
  isServer: selIsServer,
  isModalOpen: selIsModalOpen,
  cfLocation: selCfLocation,
  ipCountryIso2: selIpCountryIso2,
  ipStateIso2: selIpStateIso2,
};
